// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"88b69e33","455":"50130d42","977":"8b15f426"}[chunkId] + ".chunk.js";
};